export default "__VITE_ASSET__BN2ITNS7__"